export default function organizationslas(state = [], action) {
    switch (action.type) {
        case 'ADD_CURRENT':
            return {
                ...state,
                organizationsla: action.organizationsla,
            }
        case 'ADD_CURRENT_ORGANIZATION':
          return {
              ...state,
              organizationsla: action.organizationsla,
              organization: action.organization,
          }
        default:
            return state;
    }
}
